module.exports = __webpack_public_path__ + "img/experience-icon.83517b68.svg";